import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';

import { PreviewService } from '../../../../../services/preview/preview.service';

@Component({
  selector: 'dashboard-orbits-canvas-preview',
  templateUrl: './orbits-canvas-preview.component.html',
  styleUrls: ['./orbits-canvas-preview.component.scss'],
})
export class OrbitsCanvasPreviewComponent implements OnInit, OnDestroy {
  @Input() initialNumberOfOrbits: number;
  @ViewChild('orbitCanvas', { static: true }) orbitCanvas: ElementRef;

  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  xCenter: number;
  yCenter: number;
  rOuter: number;
  rCenter: number;
  rIcon = 14;
  rDelta: number;
  outerOrbitPartsNumber = 12;
  numberOfOrbits: number;

  private subscriptions = new Subscription();

  constructor(private previewService: PreviewService) {}

  ngOnInit(): void {
    this.numberOfOrbits = this.initialNumberOfOrbits;

    this.drawOrbitsCanvas();

    this.subscriptions.add(
      this.previewService.previewData$.subscribe((previewData) => {
        if (previewData?.numberOrbits) {
          this.numberOfOrbits = previewData?.numberOrbits;
          this.drawOrbitsCanvas();
        }
      })
    );
  }

  drawOrbitsCanvas(): void {
    this.canvas = this.orbitCanvas.nativeElement as HTMLCanvasElement;

    const parentWidth = document.getElementById('orbits-canvas-preview').offsetWidth;
    this.canvas.height = parentWidth + 20;
    this.canvas.width = parentWidth;
    this.rOuter = this.canvas.width / 2 - 15;
    this.xCenter = this.canvas.width / 2;
    this.yCenter = this.canvas.width / 2 + 10;

    this.ctx = this.canvas.getContext('2d');
    this.ctx.textBaseline = 'middle';
    this.ctx.textAlign = 'center';
    setTimeout(() => {
      this.ctx.font = '15px Material Icons';
      this.draw();
    }, 500);

    this.rCenter = 4 + this.rIcon;
    this.rDelta = (this.rOuter - this.rCenter) / (1 + this.numberOfOrbits);
  }

  draw(): void {
    if (this.canvas && this.ctx) {
      this.ctx.fillStyle = '#ffffff';
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
      this.drawOrbits();
      this.drawOuterOrbit();
      this.drawCenter();
    }
  }

  drawOrbits(): void {
    for (let i = 1; i <= this.numberOfOrbits; i++) {
      this.ctx.beginPath();
      this.ctx.arc(this.xCenter, this.yCenter, this.rDelta * i + this.rCenter, 0, Math.PI * 2, false);
      this.ctx.stroke();
      this.ctx.strokeStyle = '#4d4d4d';
    }
  }

  drawOuterOrbit(): void {
    const angle = Math.PI / this.outerOrbitPartsNumber;

    for (let i = 1; i <= this.outerOrbitPartsNumber; i++) {
      this.ctx.beginPath();
      this.ctx.arc(this.xCenter, this.yCenter, this.rOuter, (2 * i - 0.5) * angle, (2 * i + 0.5) * angle);
      this.ctx.stroke();
    }
  }

  drawCenter(): void {
    this.ctx.beginPath();
    this.ctx.arc(this.xCenter, this.yCenter, this.rCenter, 0, Math.PI * 2, false);
    this.ctx.stroke();
    this.ctx.beginPath();
    this.ctx.arc(this.xCenter, this.yCenter, this.rCenter, 0, Math.PI * 2, false);
    this.ctx.lineWidth = 3;
    this.ctx.stroke();
    this.ctx.lineWidth = 1;
    this.ctx.fillStyle = '#ffffff';
    this.ctx.fill();
    this.ctx.fillStyle = '#000000';
    this.ctx.fillText('person', this.xCenter, this.yCenter);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
